// extracted by mini-css-extract-plugin
export default {"CollapsibleTable":"EunTNU","collapsed":"Johata"};